export const FETCH_QUALIFICATIONS = "FETCH_QUALIFICATIONS";
export const FETCH_QUALIFICATIONS_SUCCESS = "FETCH_QUALIFICATIONS_SUCCESS";
export const FETCH_QUALIFICATIONS_FAILURE = "FETCH_QUALIFICATIONS_FAILURE";

export const CREATE_QUALIFICATION_REQUEST = "CREATE_QUALIFICATION_REQUEST";
export const CREATE_QUALIFICATION_SUCCESS = "CREATE_QUALIFICATION_SUCCESS";
export const CREATE_QUALIFICATION_FAILURE = "CREATE_QUALIFICATION_FAILURE";

